import axiosInstance from "../variables/api/axiosInstance";

/**
 * Surcouche générique : applique l'agence et/ou l'intermédiaire ciblés + le taux de
 * commission sur le contrat résultant d'un avenant (quel que soit l'avenant), et
 * déclenche le recalcul de commission côté backend. À appeler dans le handler de
 * succès de chaque modal d'avenant.
 *
 * - `codeId`        : codeId du contrat retourné par l'avenant.
 * - `agence`        : objet Agence sélectionné (ou null).
 * - `taux`          : taux de commission effectif récupéré (ou null).
 * - `intermediaire` : objet Intermédiaire sélectionné (ou null) — optionnel.
 *
 * Sans effet si rien n'est fourni (cas non-siège). Échec silencieux :
 * l'avenant reste valide même si la surcouche échoue.
 */
export const applyAvenantAgenceCommission = async (codeId, agence, taux, intermediaire) => {
    if (!codeId) return;
    const agenceCode = agence?.codeAgence || agence?.codeId || null;
    const intermediaireCode = intermediaire?.codeIntermediaire || null;
    if (!agenceCode && !intermediaireCode && taux == null) return;
    try {
        await axiosInstance.put(`/api/contrat/${codeId}/agence-commission`, {
            agenceCode,
            // Identifiant exact : un courtier peut porter le même code qu'une agence de la compagnie.
            agenceCodeId: agence?.codeId || null,
            intermediaireCode,
            tauxCommission: taux != null ? taux : null,
        });
    } catch (e) {
        console.log("applyAvenantAgenceCommission:", e);
    }
};
